module.exports = __webpack_public_path__ + "img/elportal.d3700f13.png";